<template>
  <section class="wizard-summary">
    <section class="wizard-summary__head">
      <h2><span class="mobile-hide">Help Me Choose a Platform - </span>Summary</h2>
      <a
        @click.prevent="goBack('top')"
        href="#"
        class="link--go-back"
      >
        Go Back
      </a>
    </section>
    <section class="wizard-summary__body">
      <div class="body__content" v-if="isWizardDataAvailable">
        <div class="wizard-summary__flex">
          <div class="wizard-summary__flex--left">
            <p>
              If you need to change any of your selections,
              <strong><a href="#" @click.prevent="goBack('link')">go back to Step 1 of
              'Help Me Choose a Platform'</a></strong>.
              To see which platforms are most compatible with your selections, click
              <strong><a href="#" @click.prevent="beginWizardFiltering('link')">see your results</a></strong>.
            </p>
          </div>
          <div class="wizard-summary__flex--right">
            <unum-button @click.native.prevent="beginWizardFiltering('button')">
              See Your Results
            </unum-button>
          </div>
        </div>
        <div
          class="table-wrapper"
          @click.prevent="handleClick($event)"
        >
          <table class="summary-table">
            <thead>
              <tr>
                <th>Question</th>
                <th>Answer</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>

              <tr>
                <td>Do you need support for core benefits?</td>
                <td>{{ wizardAnswers.core_benefits ? 'Yes' : 'No' }}</td>
                <td></td>
              </tr>

              <tr>
                <td>What products will you be offering?</td>
                <td>
                  <template
                    v-for="(product, prodKey) in wizardAnswers.products"
                  >
                    <div v-if="!!product.supported" :key="prodKey" class="product-offered">
                      <p class="wizard-summary__product">{{ prodNameLookup(prodKey) }} Insurance</p>

                      <ul
                        v-if="product.standAlonePoliciesSupported ||
                          product.stackedCoverageSupported"
                      >
                        <li v-if="product.standAlonePoliciesSupported">
                          <strong>
                            {{ product.standAlonePoliciesSupported ? 'With' : 'No' }}
                          </strong>
                          Stand Alone Policies
                        </li>
                        <li v-if="product.stackedCoverageSupported">
                          <strong>
                            {{ product.stackedCoverageSupported ? 'With' : 'No' }}
                          </strong>
                          Stacked Coverage
                        </li>
                      </ul>
                    </div>
                  </template>
                </td>
                <td></td>
              </tr>

              <tr>
                <td>Will there be employer paid products?</td>
                <td>{{ wizardAnswers.employerPaidSupport ? 'Yes' : 'No' }}</td>
                <td></td>
              </tr>

              <tr>
                <td>Will 75% of your employees be seen or spoken to?</td>
                <td>{{ wizardAnswers.employee_75_seen_spoken ? 'Yes' : 'No' }}</td>
                <td>
                  <p v-if="wizardAnswers.employee_75_seen_spoken">
                    You may qualify for the POPS Program with specific platforms.
                    Email:
                    <a href="mailto:PartnerManagement@ColonialLife.com" @click="logEvent('clicked_wizard_summary_partnermanagement@coloniallife.com_link')">
                      PartnerManagement@ColonialLife.com
                    </a>
                  </p>
                  <p v-else>
                    If 75% of your employees are seen or spoken to, you may qualify for the POPS Program with specific platforms.
                    Email:
                    <a href="mailto:PartnerManagement@ColonialLife.com" @click="logEvent('clicked_wizard_summary_partnermanagement@coloniallife.com_link')">
                      PartnerManagement@ColonialLife.com
                    </a>
                  </p>
                </td>
              </tr>

              <tr>
                <td>How do you plan to enroll?</td>
                <td>
                  <template v-for="(feature, featureKey) in wizardAnswers.features">
                    <p v-if="!!feature.available" :key="featureKey">
                      {{ featureKey.split('_').join(' ') }}
                    </p>
                  </template>
                </td>
                <td>
                  <p v-if="wizardAnswers.features.auto_census_enroll.available">
                    For more information on extended timing, refer to the Underwriting CARES Team:
                    <a href="mailto:uwCaresTeamCol@unum.com" @click="logEvent('clicked_wizard_summary_uwcaresteamcol@unum.com_link')">uwCaresTeamCol@unum.com</a>
                  </p>
                </td>
              </tr>

              <tr>
                <td>Who will be building the case?</td>
                <td>
                  <p v-if="!!wizardAnswers.buildCaseColonialLifeOffice">
                    Broker / Coordinator
                  </p>
                  <p v-if="!!wizardAnswers.buildCaseBrokerIntegratedPartner">
                    System / Vendor
                  </p>
                  <p v-if="!!!wizardAnswers.buildCaseBrokerIntegratedPartner &&
                    !!!wizardAnswers.buildCaseColonialLifeOffice">
                    Either Broker / Coordinator <strong>OR</strong> System / Vendor
                  </p>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import UnumButton from '@/components/ui/Button'
import sessionEvent from '@/util/sessionEvent'

export default {
  data () {
    return {
      productsCache: null
    }
  },
  components: {
    UnumButton
  },
  // moved to start screen for whole app availability
  // async created () {
  //   const productsCache = await db.ref('blueprints/products').once('value')
  //     .then(function (productsBluePrint) {
  //       let productsWithKey = {}
  //       Object.entries(productsBluePrint.val())
  //         .forEach(productEntryKey => {
  //           productsWithKey[productEntryKey[0]] = productEntryKey[1]
  //         })
  //       return productsWithKey
  //     })
  //   this.$store.dispatch('platforms/setProductsCache', productsCache)
  // },
  beforeMount () {
    this.productsCache = this.products
    if (!this.isWizardDataAvailable) {
      this.$modal.show('dialog', {
        title: 'Information',
        text: `No existing data for 'Help Me Choose' path. You will be redirected to the home screen.`,
        buttons: [
          {
            title: 'Ok',
            handler: () => {
              this.$modal.hide('dialog')
              this.$router.push({ name: 'Home' })
            }
          }
        ]
      })
    }
  },
  computed: {
    ...mapState('platforms', [
      'products'
    ]),
    ...mapState('user', [
      'session'
    ]),
    ...mapState('wizard', [
      'wizardAnswers'
    ]),
    ...mapGetters('wizard', [
      'isWizardDataAvailable'
    ])
  },
  methods: {
    ...mapActions('wizard', [
      'filter',
      'clearWizard'
    ]),
    capitalize (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    prodNameLookup (productKey) {
      return this.productsCache[productKey].displayName
    },
    beginWizardFiltering (elementType) {
      console.count('FILTERING HAS BEGUN!!!')
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, `clicked_wizard_summary_see_results_${elementType}`)
      this.filter()
        .then(res => {
          this.$router.push({ name: 'Compare' })
        })
        .catch(err => {
          console.log(err)
        })
    },
    goBack (elementType) {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, `clicked_wizard_summary_go_back_${elementType}`)
      this.$router.go(-1)
    },
    logEvent (eventAction) {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, eventAction)
    },
    handleClick (e) {
      if (Element.prototype.msMatchesSelector) {
        if (e.target.msMatchesSelector('a')) {
          window.open(e.target.getAttribute('href'))
        }
      } else {
        if (e.target.matches('a')) {
          window.open(e.target.getAttribute('href'))
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    // next()
    if (to.name !== 'Compare' && to.name !== 'Wizard' && this.isWizardDataAvailable) {
      this.$modal.show('dialog', {
        title: 'Caution',
        text: `By navigating away, you will lose any selections or results so far.`,
        buttons: [
          {
            title: 'Cancel',
            handler: () => {
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'Ok',
            handler: () => {
              this.clearWizard()
              this.$modal.hide('dialog')
              next()
            }
          }
        ]
      })
    } else {
      next()
    }
  }
}
</script>

<style lang="scss" scoped>
.wizard-summary {
  &__head {
    // height: 8rem;
    height: 4.688rem;
    background: $lightBlue;
    padding: .75rem 2rem;
    display: flex;
    justify-content: space-between;
    align-items: left;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
    position: relative;
    z-index: 1;
    flex-flow: column nowrap;

    @include bp($small) {
      padding: .75rem 3rem;
    }

    h2 {
      color: $blue;
      font-weight: 600;
      margin: 0;
      order: 1;
    }
  }

  &__body {
    background: #fff;
    // padding: 0 0 0 3rem;
    overflow: hidden;
    height: calc(100% - 4.688rem);
    // padding-top: 1.5rem;
    overflow: auto;
  }

  &__footer {
    height: 3.125rem;
    background: #fff;
  }

  &__flex {
    padding: 2rem;
    justify-content: space-between;

    @include bp($small) {
      display: flex;
      padding: 2rem 3rem;
    }

    &--left,
    &--right {
      @include bp($small) {
        width: 50%;
      }
    }

    &--right {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    p {
      @include bp($medium, 'max-width') {
        font-size: 1.25rem;
      }
    }
  }

  &__product {
    color: $blue;
    font-weight: 600;
  }

}

.summary-table {
  width: 100%;
  border-collapse: collapse;

  thead {
    background: #d8e5ee;
    th {
      padding: 1rem 3rem;
      text-align: left;
      width: 33.333%;
    }
  }

  tr {
    &:nth-child(even) {
      background: #f7f7f7;
    }
  }

  td {
    padding: 1rem;
    border: .063rem solid $lightBlue;
    border-top: 0;
    border-bottom: 0;
    color: $superDarkBlue;
    font-size: .875rem;
    word-break: break-word;
    vertical-align: top;

    @include bp($medium) {
      padding: 1rem 3rem;
    }

    &:first-child {
      font-weight: 600;
    }

    p {
      text-transform: capitalize;
      margin: 0 auto;
      & + p {
        margin-top: 1rem;
      }
    }

    ul {
      list-style: none;
      padding-left: 1rem;
      margin: .25rem 0;

      li {
        margin-bottom: .25rem;
      }
    }

    .product-offered {
      & + .product-offered {
        margin-top: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WizardSummary.vue